import React from "react";

export default function FloatingBackground() {
  return (
    <div style={styles.container}>
      
      {/* Sky */}
      <div style={styles.sky} />

      {/* Multi-peak mountains */}
      <svg viewBox="0 0 1440 320" preserveAspectRatio="none" style={styles.mountains}>
        <path
          d="
          M0 220 
          L60 200 L120 215 L180 190 L240 210 L300 185 L360 205 L420 180
          L480 210 L540 190 L600 215 L660 195 L720 220 L780 200
          L840 215 L900 190 L960 210 L1020 185 L1080 205
          L1140 180 L1200 210 L1260 190 L1320 215 L1380 195 L1440 210
          L1440 320 L0 320 Z"
          fill="#D8DCEB"
        />
      </svg>

      {/* Continuous moving cloud sea */}
      <div className="cloudSea" />

      <style>{css}</style>
    </div>
  );
}

const styles = {
  container: {
    position: "fixed",
    inset: 0,
    overflow: "hidden",
    zIndex: 0,
    background: "#ECEEF5",
  },

  sky: {
    position: "absolute",
    inset: 0,
    background: "linear-gradient(180deg, #FAFBFE 0%, #ECEEF5 65%)",
  },

  mountains: {
    position: "absolute",
    bottom: "22%",
    width: "100%",
    height: "38%",
  },
};

const css = `
.cloudSea {
  position: absolute;
  bottom: 0;
  width: 200%;
  height: 260px;
  background:
    radial-gradient(circle at 10% 60%, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0) 60%),
    radial-gradient(circle at 30% 50%, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0) 60%),
    radial-gradient(circle at 50% 55%, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0) 60%),
    radial-gradient(circle at 70% 50%, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0) 60%),
    radial-gradient(circle at 90% 60%, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0) 60%);
  
  background-size: 400px 200px;
  background-repeat: repeat-x;
  filter: blur(14px);
  opacity: 0.95;

  animation: moveCloudSea 120s linear infinite;
}

@keyframes moveCloudSea {
  from { transform: translateX(0%); }
  to   { transform: translateX(-50%); }
}
`;
